import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface NoAvailabilityModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onStayOnPage: () => void;
  onGoToResults: () => void;
}

export function NoAvailabilityModal({
  open,
  onOpenChange,
  onStayOnPage,
  onGoToResults
}: NoAvailabilityModalProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-amber-100">
              <AlertTriangle className="h-6 w-6 text-amber-600" />
            </div>
            <div>
              <DialogTitle>{t('noAvailability.title')}</DialogTitle>
              <DialogDescription className="mt-1">
                {t('noAvailability.description')}
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="py-4">
          <p className="text-sm text-muted-foreground">
            {t('noAvailability.question')}
          </p>
        </div>

        <DialogFooter className="flex-col gap-2 sm:flex-row">
          <Button variant="outline" onClick={onStayOnPage} className="w-full sm:w-auto">
            {t('noAvailability.stayOnPage')}
          </Button>
          <Button onClick={onGoToResults} className="w-full sm:w-auto">
            {t('noAvailability.goToResults')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
